import React from "react";
const DividerComponent = ({
  text
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: "relative divider"
  }, /*#__PURE__*/React.createElement("div", {
    className: "absolute inset-0 flex items-center",
    "aria-hidden": "true"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-full border-t border-gray-300 customizable"
  })), /*#__PURE__*/React.createElement("div", {
    className: "relative flex justify-center"
  }, /*#__PURE__*/React.createElement("span", {
    className: "bg-white px-2 text-sm text-gray-500 customizable"
  }, text)));
};
export { DividerComponent };